import React, {Component} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Table} from "reactstrap";
import {excludedAttributes} from "./AccountProductsConstants";
import {sortBy} from "../../../../utils";
import ApiProductsService from "../../../../services/api-products-service";
import AttributeService from "../../../../services/attributes-service";
import ToastOptions from "../../../../common/toast/toastr-config.js";
import Loading from "../../../../common/Loading/Loading";
import AddButton from "../../../../common/AddButton/AddButton";
import CreateDialog from "../../../../common/CreateDialog/CreateDialog";
import toastr from "toastr";
import "./Attributes.css";

class Attributes extends Component {
  mount = false;
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      attributes: [],
      name: "",
      newValue: "",
      invalidFields: {
        value: {
          invalid: false,
          message: ""
        }
      },
      isAddValueModalVisible: false,
      isDialogLoading: false
    };
  }

  componentWillMount() {
    this.mount = true;
    this.fetchAttributes();
  }

  componentWillUnmount() {
    this.mount = false;
  }


  fetchAttributes = async () => {
    //Determine what services this subscription has so that we can get the appropriate products
    const services = this.props.sub && this.props.sub.connectedProducts ? this.props.sub.connectedProducts[0].services : [];

    if (services) {
      try {
        //Get a list of all the APIGee products with attributes
        const response = await ApiProductsService.getApigeeServices();

        const attributes = [];
        services.forEach(service => {
          const apigeeService = response.data.find(
              s => s.name === service.serviceName
          );
          //A found service means we have the apigee product {name, attributes, displayName}
          if (apigeeService) {

            apigeeService.attributes.forEach(attribute => {
              if (
                !attributes.find(a => a.name === attribute.name) &&
                !excludedAttributes.includes(attribute.name) &&
                attribute.name.indexOf("system-") !== 0
              ) {

                const foundAttribute = this.props.sub.attributes !== undefined ? this.props.sub.attributes.find(f => f.name === attribute.name) : undefined;
                if (foundAttribute) {
                  const att = {
                    name: foundAttribute.name,
                    value: foundAttribute.value,
                    description: AttributeService.description([foundAttribute.name], foundAttribute.value)
                  };
                  if (this.mount) {
                    this.setState({newValue: foundAttribute.value});
                  }
                  attributes.push(att);
                } else {
                  let att = {
                    name: attribute.name,
                    value: "",
                    description: AttributeService.description([attribute.name], attribute.value)
                  };
                  if (this.mount) {
                    this.setState({ newValue: "" });
                  }
                  attributes.push(att);
                }
              }
            });
          }
        });

        if (this.mount) {
          this.setState({
            attributes: sortBy(attributes, "name"),
            loading: false
          });
        }
      } catch (error) {
        toastr.options = ToastOptions;
        toastr.error(error.message);
        if (this.mount) {
          this.setState({ loading: false });
        }
      }
    } else {
      if (this.mount) {
        this.setState({ loading: false });
      }
    }
  };

  handleAddValueDialogToggle = () => {
    if (!this.state.isAddValueModalVisible) {
      this.setState({
        isAddValueModalVisible: !this.state.isAddValueModalVisible
      });
    }
  };

  resetState = () => {
    this.setState({
      newValue: "",
      invalidFields: {
        value: {
          invalid: false,
          message: ""
        }
      },
      isAddValueModalVisible: false,
      name: ""
    });
  };

  validateValue = e => {
    this.setState({
      newValue: e.target.value
    });
  };

  editAccountAttribute = async () => {
    // if(!this.state.invalidFields.value.invalid && this.state.newValue.trim() !== "") {
    try {
      this.setState({isDialogLoading: true});
      //Make a copy of the account
      let account = {...this.props.account};
      //Get the appropriate subscription reference
      let accountSub = account.subscriptions.find(sub => sub.unitId === this.props.sub.unitId
          && sub.connectedProducts[0].productId === this.props.sub.connectedProducts[0].productId);
      //If we don't have any attributes for the sub yet, create an array for the subs
      if (!accountSub.attributes) accountSub.attributes = [];
      //Find the updated attribute within the subscription.  If it does not exist already we will create a new one.
      let subAttribute = accountSub.attributes.find(as => as.name === this.state.name);
      //If it does not exist we will add it
      if (!subAttribute) {
        subAttribute = {
          name: this.state.name,
          value: this.state.newValue
        }
        accountSub.attributes.push(subAttribute);
      } else {
        //Set the updated value
        subAttribute.value = this.state.newValue;
      }

      //Save
      if (accountSub.connectedProducts[0].type === "API") {
        //Flag as unsynced with APIGee
        accountSub.isSynchronize = false;
      }
      this.props.updateSubscription(accountSub);
      //Update the attributes
      let updatedAttribute = this.state.attributes.find(a => a.name === this.state.name);
      updatedAttribute.value = this.state.newValue;
      this.setState({
        sub: accountSub,
        attributes: this.state.attributes,
        isAddValueModalVisible: false,
        isDialogLoading: false
      });
      toastr.options = ToastOptions;
      toastr.success("Attribute has been updated.");
      this.resetState();
    } catch (error) {
      this.setState({ isDialogLoading: false });
      toastr.options = ToastOptions;
      toastr.error(error.message);
    }
  };

  populateTable = () => {
    //Don't display the company id or DisplayName attributes.
    return this.state.attributes.map((attribute, i) => {
      return (
        <tr key={i}>
          <td className="width-20">{attribute.name}</td>
          <td className="width-20">
            {attribute.value !== "" ? (
              attribute.value
            ) : this.props.isActive && (
              <div onClick={() => this.setState({ name: attribute.name })}>
                <AddButton
                  name="Add"
                  handleCreateDialogToggle={this.handleAddValueDialogToggle}
                  className="btn-add-attribute"
                />
              </div>
            )}
          </td>

          <td className={`${this.props.isActive ? "width-10" : "width-0"}`}>
            {this.props.sub.isActive &&
            <FontAwesomeIcon
                className="edit edit-icon"
                icon="edit"
                size="sm"
                color="#59595B"
                onClick={() => {
                  this.handleAddValueDialogToggle();
                  this.setState({
                    newValue: attribute.value,
                    name: attribute.name
                  });
                }}
            />
            }
          </td>
          <td className={`${this.props.isActive ? "width-50" : "width-60"}`}>{attribute.description}</td>
        </tr>
      );
    });
  };

  render() {
    return (
      <div className="account-attributes">
        {this.state.loading ? (
          <Loading className="attributes-loading" />
        ) : (
          <div className="attributes-table">
            <Table className="table">
              <thead>
                <tr>
                  <th className="width-20">Name</th>
                  <th className="width-20">Value</th>
                  <th className={`${this.props.isActive ? "width-10" : "width-0"}`}>{this.props.isActive ? "Edit" : ""}</th>
                  <th className={`${this.props.isActive ? "width-50" : "width-60"}`}>Description</th>
                </tr>
              </thead>
              <tbody>{this.populateTable()}</tbody>
            </Table>
          </div>
        )}

        {/* Add/Edit attribute value */}
        <CreateDialog
          isModalVisible={this.state.isAddValueModalVisible}
          isDialogLoading={this.state.isDialogLoading}
          handleDialogToggle={this.handleAddValueDialogToggle}
          cancelAction={this.resetState}
          action={this.editAccountAttribute}
          modalHeaderName={this.state.name}
          modalBodyFields={[
            {
              label: "Value",
              id: "value",
              inputType: "text",
              onChange: this.validateValue,
              validateFieldName: "",
              isFieldInvalid: this.state.invalidFields.value.invalid,
              invalidFieldMessage: this.state.invalidFields.value.message,
              newField: this.state.newValue,
              defaultValue: this.state.newValue
            }
          ]}
        />
      </div>
    );
  }
}

export default Attributes;



// WEBPACK FOOTER //
// ./src/accounts/account-product-details/account-api-product-details/components/Attributes.js